import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { TranslateService } from '@shared/services/translate';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';
import { TogglePasswordDirective } from '../../../../shared/directives/toggle-password.directive';
import { Ripple } from 'primeng/ripple';
import { Bind } from 'primeng/bind';
import { Checkbox } from 'primeng/checkbox';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';

@Component({
    selector: 'login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, TogglePasswordDirective, Ripple, Bind, Checkbox, NgClass, TranslatePipe]
})
export class LoginFormComponent implements OnInit {
  loginGroup: UntypedFormGroup;
  password: UntypedFormControl;
  username: UntypedFormControl;
  rememberMe: UntypedFormControl;

  @Output() saveEmit: EventEmitter<any> = new EventEmitter<any>();

  @Input() set activeProgress(val: boolean) {
    this._activeProgress = val;
    if (this.loginGroup) {
      if (val) {
        this.password.disable();
        this.username.disable();
      } else {
        this.password.enable();
        this.username.enable();
      }
    }
  }
  get activeProgress() {
    return this._activeProgress;
  }

  @Input() set formDisable(val: boolean) {
    if (this.loginGroup) {
      if (val) {
        this.loginGroup.disable();
      } else {
        this.loginGroup.enable();
        this.activeProgress = false;
      }
    }
  }

  hide: boolean = true;

  _activeProgress: boolean = false;
  devMode: boolean = true;

  constructor(
    public translate: TranslateService,
    private _router: Router
  ) {
    if(!this._router.url.includes('rana')) {
      this.devMode = false;
    } else {
      this.devMode = true;
    }
  }

  ngOnInit() {
    this.loginGroup = this.initForm();
  }

  initForm(): UntypedFormGroup {
    const nonWhitespaceRegExp: RegExp = new RegExp("\\S");
    this.username = new UntypedFormControl(null, [Validators.required, Validators.email]);
    this.password = new UntypedFormControl(null, [Validators.required, Validators.pattern(nonWhitespaceRegExp)]);
    this.rememberMe = new UntypedFormControl();
    return new UntypedFormGroup({
      'username': this.username,
      'password': this.password,
      'remember_me': this.rememberMe
    });
  }


  saveBtn() {
    this._activeProgress = true;
    if (this.loginGroup.invalid) {
      this.loginGroup.markAllAsTouched();
      this._activeProgress = false;
    } else {
      this.save();
    }
  }

  save() {
    const model = this.loginGroup.getRawValue();
    this.saveEmit.emit(model);
  }
}
